import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pfs-placeholder.svg")